var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportIconCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26091",
    "data-name": "Group 26091",
    transform: "translate(-313 -411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25463",
    "data-name": "Group 25463",
    transform: "translate(-943 -708)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1564",
    "data-name": "Ellipse 1564",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(1256 1119)",
    fill: "#b5b5b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25465",
    "data-name": "Group 25465",
    transform: "translate(-403.773 -617.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7369",
    "data-name": "Path 7369",
    d: "M728.438,1041.7a.3.3,0,0,0,.222-.1l2.156-2.253a.308.308,0,0,0-.222-.521h-1.129v-2.36a.514.514,0,0,0-.513-.513h-1.027a.515.515,0,0,0-.513.513v2.36h-1.129a.308.308,0,0,0-.307.309.3.3,0,0,0,.085.212l2.155,2.253A.3.3,0,0,0,728.438,1041.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7384",
    "data-name": "Path 7384",
    d: "M732.469,1040.554a.637.637,0,0,0-.637.635v2.076h-6.787v-2.073a.636.636,0,1,0-1.271,0v2.71h0a.623.623,0,0,0,.3.531.616.616,0,0,0,.329.106h8.059a.621.621,0,0,0,.383-.141.587.587,0,0,0,.067-.044c.011-.011.016-.027.026-.039a.632.632,0,0,0,.161-.41h0v-2.71A.638.638,0,0,0,732.469,1040.554Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIconCircle);
export default __webpack_public_path__ + "static/media/export-icon_circle.85275c5c4960951e355866c46e30a593.svg";
export { ForwardRef as ReactComponent };